"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render_height = exports.render_width = void 0;
const CGJHUDScene_1 = require("./CGJHUDScene");
const CGJMenuScene_1 = require("./CGJMenuScene");
const CGJCreditsScene_1 = require("./CGJCreditsScene");
const CGJGameScene_1 = require("./CGJGameScene");
const CGJExpositionScene_1 = require("./CGJExpositionScene");
const CGJWinScene_1 = require("./CGJWinScene");
const CGJPreloadScene_1 = require("./CGJPreloadScene");
const KHAudioScene_1 = require("./KH/KHAudioScene");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
exports.render_width = screen.width;
exports.render_height = screen.width * 9 / 16;
const config = {
    type: Phaser.AUTO,
    backgroundColor: '#222222',
    parent: "cgj-game",
    scale: {
        width: 1920,
        height: 1080,
        mode: Phaser.Scale.FIT,
        autoCenter: Phaser.Scale.CENTER_HORIZONTALLY
    },
    input: {
        gamepad: true,
    },
    scene: [CGJPreloadScene_1.CGJPreloadScene, CGJHUDScene_1.CGJHUDScene, CGJGameScene_1.CGJGameScene, CGJMenuScene_1.CGJMenuScene, CGJCreditsScene_1.CGJCreditsScene, CGJWinScene_1.CGJWinScene, CGJExpositionScene_1.CGJExpositionScene, KHAudioScene_1.KHAudioScene, KHInputScene_1.KHInputScene],
    physics: { default: 'arcade', arcade: { debug: false } },
};
const game = new Phaser.Game(config);
